import { A11y, Navigation, Scrollbar } from 'swiper/modules';

class RecipeDetailProducts {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-recipedetailproducts'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$relatedProducts = $element;
        this.$$relatedProductsSlides = this.$relatedProducts.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.$relatedProductsSlider = null;

        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;

        if (this.$$relatedProductsSlides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                './../../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
        }
        // this.initialize();
    }

    initialize () {
        this.checkSize();
        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 1024 && this.$$relatedProductsSlides.length > 1) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
                this.sliderActive = false;
            }
        }
    }

    initSlider () {
        this.$relatedProductsSlider = new this.Slider(this.$relatedProducts, {
            modules: [A11y, Navigation, Scrollbar],
            speed: 500,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            centeredSlides: true,
            centeredSlidesBounds: true,
            initAttr: this.settings.initAttr,
            centerInsufficientSlides: true,
            scrollbar: true,
            scrollbarAppendToControls: true
        });

        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.$relatedProductsSlider !== 'undefined' && this.$relatedProductsSlider !== null) {
            this.$relatedProductsSlider.destroy();
        }
    }
}

export { RecipeDetailProducts };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $relatedProducts = $context.querySelector('[data-recipedetailproducts="root"]');
        if ($relatedProducts) {
            const stageAPI = new RecipeDetailProducts($relatedProducts);
            $relatedProducts.API = stageAPI;
        }
    }
});
